import React from "react";
import withRouter from "../../Components/Common/withRouter";
import BrandCredit from "../../Components/Common/BrandCredit";

/**
 * Layout de auth (login/register/SA): crédito BrandCredit no rodapé (DOC 09 · LAC-044).
 * Shell autenticado não usa footer — só as telas de login.
 */
const ParticlesAuth = ({ children }: any) => {
  return (
    <React.Fragment>
      <div className="auth-page-wrapper pt-5">
        <div className="auth-page-content-wrap">{children}</div>

        <footer className="footer">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="text-center">
                  <p className="mb-0">
                    <BrandCredit />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ParticlesAuth);
